import React from "react"
import classnames from "classnames"
import styles from "./ImagesRotator.less"
import {
  H6,
  P,
  Icon180Icon,
  Icon360Icon,
  Space,
  Visible
} from 'AtomicComponents'
import {
  Image
} from 'AtomicContainers'

class ImagesRotator extends React.Component {
  constructor(props) {
    super(props)

    this.imagesRotator = null

    this.state = {
      current: props.initialIndex ? props.initialIndex : 0,
      started: false
    }
  }

  componentDidMount() {
    setTimeout(()=>{
      if (this.imagesRotator){
        this.imagesRotator.addEventListener("touchstart", this.handleTouchStart, false)
        this.imagesRotator.addEventListener("touchmove", this.handleTouchMove, false)
        this.imagesRotator.addEventListener("touchend", this.handleTouchEnd, false)
        this.imagesRotator.addEventListener("mousedown", this.handleTouchStart, false)
        this.imagesRotator.addEventListener("mousemove", this.handleTouchMove, false)
        this.imagesRotator.addEventListener("mouseup", this.handleTouchEnd, false)
        this.imagesRotator.addEventListener("mouseout", this.handleTouchEnd, false)
      }
    })
  }

  componentWillUnmount() {
    this.imagesRotator.removeEventListener("touchstart", this.handleTouchStart, false)
    this.imagesRotator.removeEventListener("touchmove", this.handleTouchMove, false)
    this.imagesRotator.removeEventListener("touchend", this.handleTouchEnd, false)
    this.imagesRotator.removeEventListener("mousedown", this.handleTouchStart, false)
    this.imagesRotator.removeEventListener("mousemove", this.handleTouchMove, false)
    this.imagesRotator.removeEventListener("mouseup", this.handleTouchEnd, false)
    this.imagesRotator.removeEventListener("mouseout", this.handleTouchEnd, false)
  }


  handleTouchStart = (event) => {
    const { current } = this.state
    this.pointerPosition = this.calculatePointerPosition(event)
    this.startFrame = current
    this.setState({ started: true })
  }

  handleTouchEnd = (event) => {
    event.preventDefault()
    this.pointerPosition = null
    this.startFrame = null
    this.setState({ started: false })
  }

  handleTouchMove = (event) => {
    const { started } = this.state
    if (!started) return

    const { vertical, imagesSrc } = this.props
    if (typeof this.pointerPosition !== "number") return
    const { offsetWidth, offsetHeight } = this.imagesRotator
    const pointer = this.calculatePointerPosition(event)
    const max = vertical ? offsetHeight : offsetWidth
    const offset = pointer - this.pointerPosition
    const delta = Math.floor(offset / ( max / 2 ) * imagesSrc.length)
    this.setCurrentFrame(this.startFrame + delta)
    this.setState({ cursorIsPoint: false })
  }

  setCurrentFrame(frame) {
    const { cycle = true, imagesSrc, onChange = () => {} } = this.props
    const { current } = this.state
    const length = imagesSrc.length
    let newCurrent = frame
    if (newCurrent < 0) newCurrent = cycle ? newCurrent + length : 0
    if (newCurrent > length - 1) newCurrent = cycle ? newCurrent - length : length - 1
    if (newCurrent !== current) {
      this.setState({
        current: Math.abs(newCurrent % length)
      })
      onChange(current)
    }
  }


  calculatePointerPosition(event) {
    const { vertical } = this.props
    const touch = event.type.indexOf("touch") === 0 ? event.changedTouches[0] : event
    const { clientX, clientY } = touch
    const { offsetTop, offsetLeft } = this.imagesRotator
    return vertical ? clientY - offsetTop : clientX - offsetLeft
  }

  render() {
    const { imagesSrc = [], cycle = true } = this.props
    const { current, started } = this.state
    return (
      <div
        ref={c => this.imagesRotator = c}
        className={classnames({
          [styles.ImagesRotator]: true,
          [styles.Grabbed]: started,
        })}
      >
        {
          imagesSrc &&
          imagesSrc.length > 0 &&
          imagesSrc.map((image,index) => (
            <div
              key={`imagesRotator-image-${index}`}
              className={classnames({
                [styles.Image]: true,
                [styles.ImageVisible]: current === index,
              })}
            >
              <Image src={image} height={400} draggable={false} />
            </div>
          ))
        }
        {/* setting the height */}
        {imagesSrc && imagesSrc[0] &&
          <div style={{opacity:0}}>
            <img src={`${imagesSrc[0]}?blur=10&quality=0.1`} draggable="false" />
          </div>
        }
        {
          cycle ?
          <div>
            <Visible visible={["mobile", "tablet"]}>
              <div style={{ width: "100%", textAlign: "right" }}>
                <span>
                  360°
                  <Icon360Icon style={{
                    width: "20px",
                    height: "17px",
                    fill: "#999999",
                    paddingLeft: "7px",
                    verticalAlign: "bottom"
                  }} />
                </span>
              </div>
            </Visible>
            <Visible visible={["screen"]}>
              <div style={{ width: "100%", textAlign: "center" }}>
                <span>
                  Drag to view 360°
                  <Icon360Icon style={{
                    width: "20px",
                    height: "17px",
                    fill: "#999999",
                    paddingLeft: "7px",
                    verticalAlign: "bottom"
                  }} />
                </span>
              </div>
            </Visible>
          </div>
          :
          <P withoutMargin>
            Drag to explore
            <Icon180Icon style={{
              width: '22px',
              height: '11px',
              paddingLeft: '7px',
              fill: '#999999'
            }} />
          </P>
        }
      </div>
    )
  }
}

export default ImagesRotator



// WEBPACK FOOTER //
// ./src/AtomicContainers/ImagesRotator/ImagesRotator.jsx